import classNames from 'classnames';
import React from 'react';
import styles from './BillingPlans.module.css';

export const ContactsManagementDescription = ({
  css,
}: {
  css?: { container?: string; content?: string };
}) => (
  <div className={classNames(styles.contactManagementWrapper, css?.container)}>
    <div className={styles.grid}>
      <div className={classNames(styles.tableData, styles.tableLabel)}>
        Totals contacts
      </div>
      <div className={classNames(styles.tableData, styles.tableLabel)}>
        Price per additional 1,000 contacts
      </div>
      <div className={styles.tableData}>Up to 50,000</div>
      <div className={styles.tableData}>+$10</div>
      <div className={styles.tableData}>50,001 - 100,000</div>
      <div className={styles.tableData}>+$9</div>
      <div className={styles.tableData}>100,001+</div>
      <div className={styles.tableData}>+$8</div>
    </div>
    <div
      className={classNames(styles.contactManagementDescription, css?.content)}
    >
      <span className={styles.bold700}>Contact management includes:</span>
      <ul className={styles.unorderedList}>
        <li>1 email send per month</li>
        <li>Enrichment of contacts - updated monthly</li>
        <li>In market analysis of contacts</li>
        <li>Returning visitor monitor</li>
        <li>Server side tracking</li>
        <li>Customer.ai contact scoring intent</li>
      </ul>
    </div>
  </div>
);
